import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ms-2 px-2 my-auto d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn",
    "data-bs-toggle": "modal",
    "data-bs-target": "#mapModal"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-map cursor-pointer text-light" })
  ])
], -1)
const _hoisted_2 = {
  class: "modal fade",
  id: "mapModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_4 = { class: "modal-content bg-dark text-light" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Modal title"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary"
  }, "Save changes")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventMap = _resolveComponent("EventMap")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_openBlock(), _createBlock(_Teleport, { to: "#globalModals" }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (_ctx.firstShow)
                ? (_openBlock(), _createBlock(_component_EventMap, { key: 0 }))
                : _createCommentVNode("", true)
            ]),
            _hoisted_7
          ])
        ])
      ])
    ]))
  ], 64))
}